import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';

import { environment } from '@unico-people/ongoing-dashboard/enviroment';
import * as fromStore from '@unico-people/shared/dashboard/data-access-store';

import {
  ChangeBenefitData,
  ReportResponseChangeBenefit,
  ResponseChangeBenefits, ResponseEmployeeRequestColumns
} from '../../interfaces/requests.model';
import { SessionStorage } from '@unico-people/shared/utils/storage';

@Injectable({ providedIn: 'root' })
export class ChangeBenefitsService {
  private url: string = environment.url;
  acc = SessionStorage.getItem('currentAccount');

  constructor(private http: HttpClient, private store: Store<any>) {
    this.store.pipe(select(fromStore.getOrganizationState)).subscribe(res => {
      this.acc = res?.currentAccount?.uid;
    });
  }

  /**
   * List change benefits employee requests
   */
  listChangeBenefitsRequests(data): Observable<any> {
    return this.http.get<ResponseChangeBenefits>(`${this.url}/change-benefits/?`, {params: data});
  }

  /**
   * List employees resquest benefits columns
   */
    listColumns(): Observable<ResponseEmployeeRequestColumns> {
      return this.http.get<ResponseEmployeeRequestColumns>(`${this.url}/change-benefits/filter-columns?type=transport`);
    }

   /**
   * Request report
   */
  requestReport(data: ChangeBenefitData): Observable<ReportResponseChangeBenefit> {
    return this.http.post<ReportResponseChangeBenefit>(`${this.url}/change-benefits/report/`, data);
  }
}
